import styles from './ServiceIconNumeric.module.scss';

import { ServiceIconShell } from '../ServiceIconShell';
import { ServiceIconSize } from '../ServiceIcon';
import { ServiceIconConfig } from '../ServiceIcon/constants';

const PDLFontMap = (iconSize: ServiceIconSize, collapsedIconCount: number) => {
  switch (iconSize) {
    case 'xx-small':
      return '--zds-minimal-print-3';
    case 'x-small':
    case 'small':
      return '--zds-body-3-multiline';
    case 'medium':
    case 'large':
      return collapsedIconCount <= 9
        ? '--zds-paragraph-header-3'
        : '--zds-body-3';
    default:
      return '--zds-paragraph-header-3';
  }
};

type ServiceIconNumericProps = {
  /*
   * Number to display within the icon box.
   */
  number: number;
  /**
   * Sets the width and height of the numeric icon. Only a limited selection
   * of sizes support the use of the numeric icon.
   */
  size: ServiceIconSize;
  /**
   * Controls the presence/absence of the border. It is recommended that a borderless ServiceIcon be
   * contained in a container with non primary color background.
   */
  hasBorder?: boolean;
  /**
   * Changes the background color to white (#fff)
   */
  hasWhiteBackground?: boolean;
};

export const ServiceIconNumeric = (props: ServiceIconNumericProps) => {
  const { size: sizeFromProps, hasBorder = true, hasWhiteBackground } = props;
  const size = sizeFromProps in ServiceIconConfig ? sizeFromProps : 'medium';

  const label = `Plus ${props.number} more apps.`;
  // If the results are greater than 99, cap the overflow result count at 99+
  const text = props.number > 99 ? `99+` : `+${props.number}`;
  const font = PDLFontMap(size, props.number);

  return (
    <ServiceIconShell
      size={size}
      hasBorder={hasBorder}
      hasWhiteBackground={hasWhiteBackground}
    >
      <span
        aria-label={label}
        className={styles.serviceIconNumeric}
        style={{
          font: `var(${font})`,
        }}
        role="img"
        data-zds
      >
        <span aria-hidden="true" data-zds>
          {text}
        </span>
      </span>
    </ServiceIconShell>
  );
};
